import $ from 'jquery';

$(function () {
    $('.collapsable .title').on('click', function (ev) {
        var $target = $(ev.target);
        $target.parent().toggleClass('open');
        $target.siblings('.copy').slideToggle('fast');
        return false;
    });
});



// WEBPACK FOOTER //
// ./src/web/js/presentation/help.js